import { SVGProps } from 'react';

const Framer = ({ props }: { props?: SVGProps<SVGSVGElement>; size?: string | number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="41" height="63" viewBox="0 0 41 63" fill="none" {...props}>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M.027.02c0 .012 4.603 4.748 10.23 10.526l10.23 10.504H0v20.9l10.25 10.525L20.5 63V41.936l10.239-.007 10.238-.007-10.225-10.429-10.226-10.429 10.237-.007L41 21.05V0H20.513C9.246 0 .027.01.027.02Z"
      clipRule="evenodd"
    />
  </svg>
);

export default Framer;
